(() => {
  if (window.AmandaRFQ) return;
  const configNode = document.getElementById('AmandaRFQConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = `amanda-rfq-v1:${config.shop}`;
  let memory = [];
  let storageAvailable = true;
  const integer = (value, min, max) => Number.isSafeInteger(Number(value)) && Number(value) >= min && Number(value) <= max;
  function clean(items) {
    if (!Array.isArray(items)) return [];
    const seen = new Set();
    return items.slice(0, 50).filter(item => {
      if (!item || !/^\d+$/.test(String(item.id)) || !/^[a-z0-9-]+$/.test(item.handle || '') || seen.has(String(item.id))) return false;
      if (!integer(item.pack, 1, 200) || !integer(item.quantity, 1, 999)) return false;
      seen.add(String(item.id));
      return true;
    }).map(item => ({
      id: String(item.id), handle: item.handle.slice(0, 180),
      title: String(item.title || '').slice(0, 180),
      article: String(item.article || '').slice(0, 80),
      ratio: String(item.ratio || '').slice(0, 240),
      pack: Number(item.pack), quantity: Number(item.quantity)
    }));
  }
  function read() {
    if (!storageAvailable) return memory;
    try {
      memory = clean(JSON.parse(localStorage.getItem(key) || '[]'));
    } catch { storageAvailable = false; }
    return memory;
  }
  function save(items) {
    memory = clean(items);
    try { localStorage.setItem(key, JSON.stringify(memory)); }
    catch { storageAvailable = false; }
    render();
  }
  function announce(message) {
    document.querySelectorAll('[data-rfq-status]').forEach(node => { node.textContent = message; });
  }
  function summary(items = read()) {
    return [config.text.summary, ...items.map((item, i) =>
      `${i + 1}. ${item.title}\n${config.text.article}: ${item.article}\n${config.text.packs}: ${item.quantity} x ${item.pack} = ${item.quantity * item.pack} ${config.text.pieces}\n${config.text.ratio}: ${item.ratio}`
    ), config.text.notice].join('\n\n');
  }
  function make(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function render() {
    const items = read();
    document.querySelectorAll('[data-rfq-count]').forEach(node => { node.textContent = String(items.length); });
    document.querySelectorAll('[data-rfq-floating]').forEach(node => { node.hidden = items.length === 0; });
    document.querySelectorAll('[data-rfq-list]').forEach(list => {
      const active = document.activeElement;
      const focusId = list.contains(active) ? active.dataset.rfqQuantity : null;
      list.replaceChildren();
      if (!items.length) list.append(make('p', config.text.empty, 'ag-empty'));
      items.forEach(item => {
        const row = make('div', undefined, 'ag-quote-row');
        const detail = make('div');
        const link = make('a', item.title, 'ag-quote-title');
        link.href = `${config.root}products/${item.handle}`;
        detail.append(link, make('p', `${config.text.article}: ${item.article}`), make('p', `${config.text.ratio}: ${item.ratio}`));
        const amount = make('div', undefined, 'ag-quote-amount');
        const label = make('label', config.text.packs);
        const input = document.createElement('input');
        input.type = 'number'; input.min = '1'; input.max = '999'; input.step = '1'; input.value = String(item.quantity);
        input.id = `rfq-quantity-${item.id}`; input.dataset.rfqQuantity = item.id; label.htmlFor = input.id;
        const remove = make('button', config.text.remove, 'ag-text-button');
        remove.type = 'button'; remove.dataset.rfqRemove = item.id;
        remove.setAttribute('aria-label', `${config.text.remove}: ${item.title}`);
        amount.append(label, input, make('p', `${item.quantity * item.pack} ${config.text.pieces}`), remove);
        row.append(detail, amount); list.append(row);
      });
      if (focusId) list.querySelector(`[data-rfq-quantity="${focusId}"]`)?.focus();
    });
    document.querySelectorAll('[data-rfq-body]').forEach(node => { node.value = items.length ? summary(items) : ''; });
    document.querySelectorAll('[data-rfq-submit]').forEach(node => { node.disabled = !items.length; });
    document.querySelectorAll('[data-rfq-total]').forEach(node => {
      node.textContent = `${items.reduce((n, item) => n + item.quantity, 0)} ${config.text.packs} · ${items.reduce((n, item) => n + item.quantity * item.pack, 0)} ${config.text.pieces}`;
    });
    if (!storageAvailable) announce(config.text.storage);
  }
  function add(data, quantity = 1) {
    const candidate = clean([{ ...data, quantity }])[0];
    if (!candidate) return false;
    const items = read().map(item => ({ ...item }));
    const existing = items.find(item => item.id === candidate.id);
    if (existing) existing.quantity = Math.min(999, existing.quantity + candidate.quantity);
    else if (items.length < 50) items.push(candidate);
    else { announce(config.text.limit); return false; }
    save(items);
    announce(storageAvailable ? config.text.added : config.text.storage);
    return true;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rfq-add]');
    if (button) {
      const card = button.closest('[data-rfq-product]');
      if (!card) return;
      try {
        const quantityInput = card.querySelector('[data-rfq-add-quantity]');
        if (quantityInput && !quantityInput.reportValidity()) return;
        const added = add(JSON.parse(card.dataset.rfqProduct), quantityInput ? Number(quantityInput.value) : 1);
        if (added) { const previous = button.textContent; button.textContent = config.text.added; setTimeout(() => { button.textContent = previous; }, 1800); }
      } catch { announce(config.text.error); }
    }
    const remove = event.target.closest('[data-rfq-remove]');
    if (remove) { save(read().filter(item => item.id !== remove.dataset.rfqRemove)); announce(config.text.updated); }
    if (event.target.closest('[data-rfq-clear]')) { save([]); announce(config.text.updated); }
    if (event.target.closest('[data-rfq-print]')) window.print();
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-rfq-quantity]');
    if (input) {
      if (!input.reportValidity()) return;
      const items = read().map(item => item.id === input.dataset.rfqQuantity ? { ...item, quantity: Number(input.value) } : item);
      save(items); announce(config.text.updated);
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-amanda-business-form]')) return;
    const country = form.querySelector('[data-business-country]');
    const vat = form.querySelector('[data-business-vat]');
    if (vat) {
      vat.setCustomValidity('');
      const value = vat.value.replace(/\s/g, '').toUpperCase();
      const countryCode = country?.selectedOptions?.[0]?.dataset.code || country?.value;
      if (value && countryCode === 'IT' && !/^(IT)?\d{11}$/.test(value)) vat.setCustomValidity(config.text.vat_error);
      if (!vat.reportValidity()) { event.preventDefault(); return; }
    }
    if (form.matches('[data-rfq-form]')) {
      for (const quantity of document.querySelectorAll('[data-rfq-quantity]')) {
        if (!quantity.reportValidity()) { event.preventDefault(); return; }
      }
      const items = read();
      if (!items.length) { event.preventDefault(); announce(config.text.empty); return; }
      form.querySelector('[data-rfq-body]').value = summary(items);
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-business-vat]')) event.target.setCustomValidity('');
  });
  window.addEventListener('storage', event => { if (event.key === key) render(); });
  document.addEventListener('shopify:section:load', render);
  if (document.querySelector('[data-rfq-success]')) save([]);
  window.AmandaRFQ = { add, read, summary, clean };
  render();
})();
